/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// Image imports
import edit_logo from "../../../../icons/edit.png";
import tash_logo from "../../../../icons/trash.png";
import constants from "../../../../utils/constants";

// Child component import
import Dropdown from "../../../Common/Dropdown";
import { getArtPackApprovedStatus } from "../../../../utils/services";

// Selector component manages the art pack selection and displays options for editing and deleting if permitted
export default function Selector({
  data,                     // array of art packs to display in the selector dropdown
  onEdit,                   // function to handle editing an art pack
  onDelete,                 // function to handle deleting an art pack
  artPack,                  // currently selected art pack ID
  setArtPack,               // function to update the selected art pack
}) {
  const navigate = useNavigate(); // navigation hook for redirection
  // State for tracking errors related to art pack name selection
  const [errorArtPackName, setErrorArtPackName] = useState(false);

  // Handle dropdown selection change, update selected ID and permission
  const handleChange = async (item) => {
    const approved = await getArtPackApprovedStatus(item); // fetch approval status
    setArtPack({
      ...item,
      approved, // check if the selected art pack is approved
    }); // update selected art pack
    setErrorArtPackName(false);
  };

  // Validate selection and navigate to the next page
  const continueNext = () => {
    if (Number(artPack?.art_pack_id) > 0) {
       setErrorArtPackName(false);
      sessionStorage.setItem(constants.ART_PACK_IDENTIFIER, artPack?.art_pack_id); // store in session for persistence
      navigate(`${constants.ARTIST_BASE_PATH}/background`); // navigate to next page
    } else {
      setErrorArtPackName(true);
    }
  };

  // Render edit/delete icons based on permission status
  const showEditOrDelete = () => {
    if(data?.length === 0) return <div className="col-sm-2 align-self-start ps-4 pt-1"/>; // return null if no data is available
    const { approved, art_pack_id } = artPack || {};
    const cursorStyle = approved ? "not-allowed" : "pointer";

    return (
      <div className="col-sm-2 align-self-start ps-4 pt-1">
        {/* Edit icon with conditional cursor style */}
        <a
          onClick={(e) => {
            if (approved) {
              alert(
                "You cannot edit this art pack because it is already used in a campaign, but you can see all the data you’ve filled."
              );
            }
            onEdit(art_pack_id);
          }}
          style={{ cursor: cursorStyle }}
        >
          <img className="edit-delete-icons" src={edit_logo} alt="Edit" />
        </a>

        {/* Delete icon with conditional cursor style */}
        <a
          onClick={(e) => {
            if (!approved) {
              onDelete(art_pack_id);
            } else {
              e.preventDefault();
            }
          }}
          style={{ cursor: cursorStyle }}
        >
          <img className="edit-delete-icons ms-3" src={tash_logo} alt="Delete" />
        </a>
      </div>
    );
  };



  return (
    <>
      {/* Art Pack selection dropdown */}
      <label htmlFor="art_pack_id" className="mb-2 form-labels">
        Select Art Pack
      </label>
      <div className="col-sm-12 d-flex justify-content-center">
        <div style={{ width: '90%' }}>
          <Dropdown category="artist" categorySubType="artPack" dropdownList={data} dropdownHeader={artPack?.art_pack_name || "Select an ArtPack"} handleChange={handleChange} />
        </div>
        {showEditOrDelete()}
      </div>

      {/* Error message if no art pack is selected */}
      {errorArtPackName && (
        <span id="errorArtPackName" className="form-text text-danger">
          Choose an option!
        </span>
      )}

      {artPack?.art_pack_id > 0 && (
        <span id="errorArtPackName" className={`form-text ${!artPack?.status ? 'text-danger' : 'text-success'}`}>
          {!artPack?.status ? `Art pack not built yet` : 'Art pack already built'}
        </span>
      )}

      {/* Continue button */}
      <div className="pt-4">
        <a onClick={continueNext} className="btn bg-orange form-btn">
          Click to continue
        </a>
      </div>
    </>
  );
}
